import React, { useEffect } from 'react';
import { PageHero } from '../components/PageHero';
import { ArtistCard } from '../components/ArtistCard';
import { artists } from '../data/artists';
import { tiAsset } from '../data/tripinkAssets';

/* All 7 Trip Ink artists, each linking to their v5 profile at /artist/<slug>. */
export function Artists() {
  useEffect(() => {
    document.title = 'The Crew | Trip Ink Tattoo Las Vegas Artists';
  }, []);
  return <>
      <PageHero title="The Crew" subtitle="Seven artists. One shop." ghost="ARTISTS" image={tiAsset('w-7104.jpg')} data-id="element-300" data-mp="3lq7zpzvhjsyk">
        <p className="tis-sub" data-id="element-301" data-mp="3hssd0bez0hbj">Artist owned and operated, at the front entrance to Hot Rod City. Tap an artist to see their work and book a day with them.</p>
      </PageHero>
      <section className="px-6 pb-[clamp(60px,6vw,160px)]" aria-label="Trip Ink artists" data-id="element-302" data-mp="3qrnjlolxftfd">
        <div className="grid gap-[clamp(16px,1.6vw,40px)] sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 min-[2200px]:grid-cols-7" data-id="element-303" data-mp="21czbhzkdcxn5">
          {artists.map(artist => <ArtistCard key={artist.slug} artist={artist} data-id="element-304" data-mp="36vbmjzpfovmb" />)}
        </div>
      </section>
    </>;
}